import db from 'src/lib/dexie-db/db';
import { NodeType } from 'src/modules/exam-preparation/graphql/common/types/node';
import { getSafeData } from './utils';
const AnswerAPIs = {
    async getForQuestion(userID, questionID) {
        const question = await db.qnaNode.get(questionID);
        if (!question ||
            ![NodeType.WRITTEN_QUESTION, NodeType.ORALS_QUESTION].includes(question.type) ||
            question.deleted) {
            throw new Error('Question not found');
        }
        const answer = await db.qnaNode
            .where('ancestors')
            .equals(question.data.duplicateRef ?? '')
            .and(node => [NodeType.WRITTEN_ANSWER, NodeType.ORALS_ANSWER].includes(node.type) &&
            !node.deleted)
            .first();
        return answer ? getSafeData(answer) : null;
    },
    getSafeData,
};
export default AnswerAPIs;
